<div class="panel-header" role="button" tabindex="0"
    (click)="toggle($event)" (keydown.enter)="toggle($event)" (keydown.space)="$event.preventDefault(); toggle($event)">
    <div class="panel-header_title">
        <ng-content></ng-content>
    </div>
    <span class="arrow"></span>
</div>